<template lang="">
    <div>
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-title
                        style="border-bottom: 1px solid #404040"
                        class="pt-2 pb-2"
                    >
                        <div
                            class="text-left"
                            style="
                                margin-left: 0;
                                width: 50%;
                                font-size: 16px;
                                font-weight: normal;
                            "
                        >
                            SEARCH FILTER
                        </div>
                    </v-card-title>

                    <v-row class="pl-4 pt-2">
                        <v-col cols="12" sm="12" md="4" lg="2" xl="2">
                            <v-autocomplete
                                label="Filter Book"
                                v-model="selectedBook"
                                :items="bookData"
                                item-text="book_name"
                                item-value="book_name"
                                auto-select-first
                                chips
                                clearable
                                deletable-chips
                                multiple
                                small-chips
                                hide-details
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="4" lg="2" xl="2">
                            <v-text-field
                                label="Volume (Greater & Equal)"
                                v-model="selectedVolume"
                                hide-details
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="4" lg="2" xl="2">
                            <v-datetime-picker
                                label="Start Date"
                                v-model="selectedStartDate"
                                hide-details
                            ></v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="2" xl="2">
                            <v-datetime-picker
                                label="End Date"
                                v-model="selectedEndDate"
                                hide-details
                            ></v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="2" xl="2">
                            <div
                                class="text-left"
                                style="margin-left: 20px; margin-top: 20px"
                            >
                                <div>
                                    <v-btn
                                        text
                                        icon
                                        color="blue lighten-2"
                                        @click="showMore()"
                                        v-if="!showMoreStatus"
                                    >
                                        More
                                        <v-icon large>
                                            mdi-chevron-down
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        text
                                        icon
                                        color="blue lighten-2"
                                        @click="showMore()"
                                        v-if="showMoreStatus"
                                    >
                                        Fewer
                                        <v-icon large> mdi-chevron-up </v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row class="pl-4" v-if="showMoreStatus">
                        <v-col cols="12" sm="12" md="4" lg="2" xl="2">
                            <v-autocomplete
                                label="Order By"
                                v-model="selectedOrderBy"
                                :items="filterOrderBy"
                                auto-select-first
                                chips
                                clearable
                                deletable-chips
                                small-chips
                                hide-details
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2">
                            <v-switch
                                style="width: 100%"
                                v-model="isAsc"
                                :label="`Is Ascending Order?`"
                                hide-details
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="2" xl="2">
                            <v-autocomplete
                                label="Show Result"
                                v-model="selectedLimit"
                                :items="filterShowResult"
                                auto-select-first
                                chips
                                clearable
                                deletable-chips
                                small-chips
                                hide-details
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <v-text-field
                                label="Login (Seprate by Comma, Eg: 10000000,200000000,300000000)"
                                v-model="selectedLogin"
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="pa-4 pt-0">
                        <v-col cols="4">
                            <v-btn
                                small
                                v-on:click="fetchVolumeRecord"
                                :loading="loading"
                                color="primary"
                                >SEARCH</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-title
                        style="border-bottom: 1px solid #404040"
                        class="pt-2 pb-2"
                    >
                        <div
                            class="text-left"
                            style="
                                margin-left: 0;
                                width: 50%;
                                font-size: 16px;
                                font-weight: normal;
                            "
                        >
                            RESULT
                        </div>
                        <div
                            class="text-right"
                            style="margin-right: 0; width: 50%"
                        >
                            <download-excel
                                :escapeCsv="false"
                                :data="tradesList"
                                name="Volume Search.csv"
                                type="csv"
                            >
                                <v-icon color="green" dark dense>
                                    mdi-microsoft-excel
                                </v-icon>
                            </download-excel>
                        </div>
                    </v-card-title>

                    <v-row>
                        <v-col cols="12">
                            <v-card flat>
                                <v-data-table
                                    dense
                                    :search="search"
                                    :headers="headers"
                                    :items="filteredDataSource"
                                    class="elevation-1"
                                    :items-per-page="10"
                                    :loading="loading"
                                    :header-props="{ sortIcon: null }"
                                >
                                    <template v-slot:header.login="{ header }">
                                        {{ header.text }}
                                        <v-menu
                                            offset-y
                                            :close-on-content-click="false"
                                            top
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        setFocus(`loginName`)
                                                    "
                                                >
                                                    <v-icon
                                                        small
                                                        :color="
                                                            loginName
                                                                ? 'primary'
                                                                : ''
                                                        "
                                                    >
                                                        mdi-filter
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <div
                                                style="
                                                    background-color: #1e1e1e;
                                                    width: 280px;
                                                "
                                            >
                                                <v-text-field
                                                    v-model="loginName"
                                                    class="px-4"
                                                    type="text"
                                                    ref="loginName"
                                                    label="Enter the search term"
                                                    style="width: 100%"
                                                ></v-text-field>
                                                <v-btn
                                                    @click="loginName = ''"
                                                    small
                                                    text
                                                    color="primary"
                                                    class="ml-2 mb-2"
                                                >
                                                    Clean
                                                </v-btn>
                                            </div>
                                        </v-menu>
                                    </template>
                                    <template v-slot:header.book="{ header }">
                                        {{ header.text }}
                                        <v-menu
                                            offset-y
                                            :close-on-content-click="false"
                                            top
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        setFocus(`bookName`)
                                                    "
                                                >
                                                    <v-icon
                                                        small
                                                        :color="
                                                            bookName
                                                                ? 'primary'
                                                                : ''
                                                        "
                                                    >
                                                        mdi-filter
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <div
                                                style="
                                                    background-color: #1e1e1e;
                                                    width: 280px;
                                                "
                                            >
                                                <v-text-field
                                                    v-model="bookName"
                                                    class="px-4"
                                                    type="text"
                                                    ref="bookName"
                                                    label="Enter the search term"
                                                    style="width: 100%"
                                                ></v-text-field>
                                                <v-btn
                                                    @click="bookName = ''"
                                                    small
                                                    text
                                                    color="primary"
                                                    class="ml-2 mb-2"
                                                >
                                                    Clean
                                                </v-btn>
                                            </div>
                                        </v-menu>
                                    </template>
                                    <template
                                        v-slot:header.total_volume="{ header }"
                                    >
                                        {{ header.text }}
                                        <v-menu
                                            offset-y
                                            :close-on-content-click="false"
                                            top
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        setFocus(`volumeName`)
                                                    "
                                                >
                                                    <v-icon
                                                        small
                                                        :color="
                                                            volumeName
                                                                ? 'primary'
                                                                : ''
                                                        "
                                                    >
                                                        mdi-filter
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <div
                                                style="
                                                    background-color: #1e1e1e;
                                                    width: 280px;
                                                "
                                            >
                                                <v-text-field
                                                    v-model="volumeName"
                                                    class="px-4"
                                                    type="text"
                                                    ref="volumeName"
                                                    label="Total volume >="
                                                    style="width: 100%"
                                                ></v-text-field>
                                                <v-btn
                                                    @click="volumeName = ''"
                                                    small
                                                    text
                                                    color="primary"
                                                    class="ml-2 mb-2"
                                                >
                                                    Clean
                                                </v-btn>
                                            </div>
                                        </v-menu>
                                    </template>
                                    <template v-slot:item.volume="{ item }">
                                        {{
                                            numberWithCommas(
                                                item.volume.toFixed(2)
                                            )
                                        }}
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { snackbar } from "@components/mixins/snackbar";
import { permission } from "@components/mixins/permission";
import { helper } from "@components/mixins/helper";

export default {
    mixins: [snackbar, permission, helper],
    data() {
        return {
            loginName: "",
            bookName: "",
            volumeName: "",
            showMoreStatus: false,
            selectedOffsetStart: 0,
            selectedLimit: 100,
            selectedOrderBy: "volume",
            selectedStartDate: null,
            selectedEndDate: null,
            selectedVolume: 0,
            selectedLogin: "",
            selectedBook: [],
            isAsc: false,
            search: "",
        };
    },
    computed: {
        ...mapState("VolumeSearch", [
            "csvHeader",
            "filterOrderBy",
            "headers",
            "filterShowResult",
            "tradesList",
            "loading",
        ]),
        ...mapState("SettingsBooks", ["bookData"]),
        filteredDataSource() {
            const conditions = [];
            if (this.loginName) {
                conditions.push(this.filterLoginName);
            }
            if (this.bookName) {
                conditions.push(this.filterBookName);
            }
            if (this.volumeName) {
                conditions.push(this.filterVolumeName);
            }
            if (conditions.length > 0) {
                return this.tradesList.filter((item) => {
                    return conditions.every((condition) => {
                        return condition(item);
                    });
                });
            }
            return this.tradesList;
        },
    },
    watch: {
        bookData(nv) {
            if (nv.length !== 0) this.selectedBook = [nv[0].book_name];
        },
    },
    methods: {
        ...mapActions("VolumeSearch", ["getVolumeAction"]),
        fetchVolumeRecord() {
            const params = {
                book: this.selectedBook,
                volume: this.selectedVolume,
                start_date: this.selectedStartDate,
                end_date: this.selectedEndDate,
                order_by: this.selectedOrderBy,
                is_asc: this.isAsc,
                limit: this.selectedLimit,
                login: this.selectedLogin,
            };
            this.$posthog.capture("volume_search_performed", {
                book_count: this.selectedBook.length,
                min_volume: this.selectedVolume,
                has_login_filter: !!this.selectedLogin,
                limit: this.selectedLimit,
            });
            this.getVolumeAction(params);
        },
        showMore() {
            this.showMoreStatus = !this.showMoreStatus;
        },
        setFocus(item) {
            setTimeout(() => {
                this.$refs[`${item}`].focus();
            }, 200);
        },
        filterLoginName(item) {
            return item.login.toString().includes(this.loginName);
        },
        filterBookName(item) {
            return item.book
                .toLowerCase()
                .includes(this.bookName.toLowerCase());
        },
        filterVolumeName(item) {
            return item.total_volume >= this.volumeName;
        },
    },
    mounted() {
        this.selectedEndDate = new Date();
        const dateOffset = 24 * 60 * 60 * 1000 * 60; // 60 days
        const startDate = new Date();
        startDate.setTime(startDate.getTime() - dateOffset);
        this.selectedStartDate = startDate;
    },
};
</script>
<style>
.v-text-field__details {
    display: none;
}
</style>
